// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'es6-promise/auto'
import Vuex from 'vuex'
import store from './store/index'
Vue.use(Vuex)

Vue.config.productionTip = false

const testing = 'woopie'

// Vue.component('album-list-item', {
//   props: ['album_data'],
//   template: '<div class="pure-u-lg-1-4 pure-u-md-1-3 pure-u-sm-1-2">Hi <div class="col-md-3"><img class="album_art" src="../assets/album_art/space_tragedy.jpg" /></div>{{ description }}</div>'
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store,
  data: {
    testing: testing
  }
})



// WEBPACK FOOTER //
// ./src/main.js